module.exports = __webpack_public_path__ + "img/loading.4386a0f3.gif";